import type { ComponentProps } from "react"
import { ORBIT_COLOR } from "~/config"
import { useTheme } from "~/components/providers/Theme"
import { getProxiedImageUrl } from "~/lib/proxy-url"
import { cn } from "~/lib/utils"

export function OrbitLogo({ ...props }: ComponentProps<"svg">) {
	return (
		<svg
			width="54"
			height="63"
			viewBox="0 0 54 63"
			xmlns="http://www.w3.org/2000/svg"
			fill={ORBIT_COLOR}
			{...props}
		>
			<path d="M4.53779 53.4974C6.67248 56.4151 9.49268 58.6472 12.9984 60.1939C16.9531 61.9386 21.6058 62.811 26.9564 62.811C32.3069 62.811 36.9596 61.9386 40.9144 60.1939C44.8691 58.4491 47.9515 55.832 50.1616 52.3425C52.3716 48.7948 53.5929 44.3748 53.8255 39.0824C53.9418 36.5816 54 34.0808 54 31.58C54 29.3828 53.9551 27.1633 53.8653 24.9213C49.078 25.6126 43.7153 27.2555 37.7663 29.8928C37.7713 30.3718 37.7738 30.8469 37.7738 31.3183C37.7738 33.5864 37.7157 36 37.5994 38.559C37.483 42.6301 36.4362 45.5961 34.4588 47.4572C32.5396 49.3183 30.0388 50.2488 26.9564 50.2488C23.874 50.2488 21.3732 49.3183 19.454 47.4572C18.1202 46.1638 17.2077 44.3368 16.7166 41.9761C11.4051 45.8355 7.36238 49.6805 4.53779 53.4974Z" />
			<path d="M2.20868 49.3529C0.965652 46.4022 0.258505 42.9787 0.0872373 39.0824C0.0290791 36.5816 0 34.0808 0 31.58C0 29.0792 0.0290791 26.5493 0.0872373 23.9903C0.319871 18.7561 1.5412 14.3651 3.75121 10.8174C6.01939 7.21163 9.13086 4.50727 13.0856 2.70436C17.0404 0.901455 21.664 0 26.9564 0C32.1906 0 36.7851 0.901455 40.7399 2.70436C44.7528 4.50727 47.8934 7.21163 50.1616 10.8174C51.9193 13.5668 53.0484 16.8225 53.5487 20.5847C48.6608 21.2513 43.3556 22.8025 37.6419 25.2038C37.6287 24.888 37.6145 24.5708 37.5994 24.252C37.483 21.5186 36.9596 19.3086 36.0291 17.622C35.1567 15.8772 33.9354 14.5977 32.3651 13.7835C30.7948 12.9693 28.9919 12.5622 26.9564 12.5622C24.979 12.5622 23.2052 12.9693 21.6349 13.7835C20.0646 14.5977 18.8142 15.8772 17.8837 17.622C16.9531 19.3086 16.4297 21.5186 16.3134 24.252C16.2552 26.6947 16.2262 29.0501 16.2262 31.3183C16.2262 33.1019 16.2442 34.9754 16.2801 36.9389C10.3762 40.986 5.66874 45.1194 2.20868 49.3529Z" />
			<path d="M23.9397 33.3473C23.1975 33.7888 22.6922 35.3986 22.6922 35.3986C22.6922 35.3986 24.3376 35.4616 24.9954 34.8962C25.3656 34.5799 25.4615 34.0108 25.1828 33.6073C25.0446 33.4144 24.8413 33.2812 24.6119 33.2332C24.3825 33.1852 24.1431 33.2258 23.9397 33.3473Z" />
			<path d="M27.278 33.2545L26.2223 31.7056C26.5582 31.1376 26.9488 30.6053 27.3883 30.1168C28.0336 29.3843 28.8497 28.8313 29.759 28.5106C30.6683 28.1899 31.6407 28.1121 32.5835 28.2845C32.3722 29.4829 31.6658 31.5297 29.1516 32.6763C28.547 32.9325 27.9193 33.1262 27.278 33.2545Z" />
			<path d="M26.2223 31.7056L24.0745 31.3268C24.0745 31.3268 24.5462 30.0336 25.2444 29.716C26.0242 29.3629 27.3922 30.0948 27.3922 30.0948" />
			<path d="M27.278 33.2545L26.8896 35.4573C26.8896 35.4573 28.2339 35.4445 28.7632 34.8792C29.3529 34.2473 29.1516 32.6763 29.1516 32.6763" />
		</svg>
	)
}

export function DiscordIcon({ ...props }: ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={36}
			height={35}
			viewBox="0 0 126.644 96"
			fill="currentColor"
			{...props}
		>
			<title>Discord</title>
			<path d="M81.15,0c-1.2376,2.1973-2.3489,4.4704-3.3591,6.794-9.5975-1.4396-19.3718-1.4396-28.9945,0-.985-2.3236-2.1216-4.5967-3.3591-6.794-9.0166,1.5407-17.8059,4.2431-26.1405,8.0568C2.779,32.5304-1.6914,56.3725.5312,79.8863c9.6732,7.1476,20.5083,12.603,32.0505,16.0884,2.6014-3.4854,4.8998-7.1981,6.8698-11.0623-3.738-1.3891-7.3497-3.1318-10.8098-5.1523.9092-.6567,1.7932-1.3386,2.6519-1.9953,20.281,9.547,43.7696,9.547,64.0758,0,.8587.7072,1.7427,1.3891,2.6519,1.9953-3.4601,2.0457-7.0718,3.7632-10.835,5.1776,1.97,3.8642,4.2683,7.5769,6.8698,11.0623,11.5419-3.4854,22.3769-8.9156,32.0509-16.0631,2.626-27.2771-4.496-50.9172-18.817-71.8548C98.9811,4.2684,90.1918,1.5659,81.1752.0505l-.0252-.0505ZM42.2802,65.4144c-6.2383,0-11.4159-5.6575-11.4159-12.6535s4.9755-12.6788,11.3907-12.6788,11.5169,5.708,11.4159,12.6788c-.101,6.9708-5.026,12.6535-11.3907,12.6535ZM84.3576,65.4144c-6.2637,0-11.3907-5.6575-11.3907-12.6535s4.9755-12.6788,11.3907-12.6788,11.4917,5.708,11.3906,12.6788c-.101,6.9708-5.026,12.6535-11.3906,12.6535Z" />
		</svg>
	)
}

export function GoogleIcon({ ...props }: ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 48 48"
			width={36}
			height={35}
			{...props}
		>
			<title>Google</title>
			<path
				fill="#EA4335"
				d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
			/>
			<path
				fill="#4285F4"
				d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
			/>
			<path
				fill="#FBBC05"
				d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
			/>
			<path
				fill="#34A853"
				d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
			/>
		</svg>
	)
}

export function GitHubIcon({ ...props }: ComponentProps<"svg">) {
	const { colorScheme } = useTheme()
	return (
		<svg
			viewBox="0 0 98 96"
			width={35}
			height={35}
			fill={colorScheme === "light" ? "black" : "white"}
			{...props}
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>GitHub</title>
			{/* Official Invertocat artwork: https://brand.github.com/foundations/logo */}
			<path d="M41.4395 69.3848C28.8066 67.8535 19.9062 58.7617 19.9062 46.9902C19.9062 42.2051 21.6289 37.0371 24.5 33.5918C23.2559 30.4336 23.4473 23.7344 24.8828 20.959C28.7109 20.4805 33.8789 22.4902 36.9414 25.2656C40.5781 24.1172 44.4062 23.543 49.0957 23.543C53.7852 23.543 57.6133 24.1172 61.0586 25.1699C64.0254 22.4902 69.2891 20.4805 73.1172 20.959C74.457 23.543 74.6484 30.2422 73.4043 33.4961C76.4668 37.1328 78.0937 42.0137 78.0937 46.9902C78.0937 58.7617 69.1934 67.6621 56.3691 69.2891C59.623 71.3945 61.8242 75.9883 61.8242 81.252L61.8242 91.2051C61.8242 94.0762 64.2168 95.7031 67.0879 94.5547C84.4102 87.9512 98 70.6289 98 49.1914C98 22.1074 75.9883 6.69539e-07 48.9043 4.309e-07C21.8203 1.92261e-07 -1.9479e-07 22.1074 -4.3343e-07 49.1914C-6.20631e-07 70.4375 13.4941 88.0469 31.6777 94.6504C34.2617 95.6074 36.75 93.8848 36.75 91.3008L36.75 83.6445C35.4102 84.2188 33.6875 84.6016 32.1562 84.6016C25.8398 84.6016 22.1074 81.1563 19.4277 74.7441C18.375 72.1602 17.2266 70.6289 15.0254 70.3418C13.877 70.2461 13.4941 69.7676 13.4941 69.1934C13.4941 68.0449 15.4082 67.1836 17.3223 67.1836C20.0977 67.1836 22.4902 68.9063 24.9785 72.4473C26.8926 75.2227 28.9023 76.4668 31.2949 76.4668C33.6875 76.4668 35.2187 75.6055 37.4199 73.4043C39.0469 71.7773 40.291 70.3418 41.4395 69.3848Z" />
		</svg>
	)
}

export function BuapeIcon({ className }: { className?: string }) {
	return (
		<img
			src={getProxiedImageUrl("https://cdn.buape.com/buape_b.png")}
			alt="Buape Auth"
			width={14}
			height={14}
			className={cn(className)}
		/>
	)
}
